import { createClientSideAuth } from "@krakentech/blueprint-auth/client"
import { apiRoutesPaths } from "@/routes/api"
import { authRoutesPaths } from "@/routes/auth"
import { dashboardRoutesPaths } from "@/routes/dashboard"

export const {
    AuthProvider,
    useGraphQLClient,
    useLogin,
    useLogout,
    useSession,
    useKrakenAuthErrorHandler,
} = createClientSideAuth(
    {
        apiRoutes: {
            graphql: {
                kraken: apiRoutesPaths.graphql.kraken.resolve(),
                oeBackend: apiRoutesPaths.graphql.oeBackend.resolve(),
            },
            login: apiRoutesPaths.login.resolve(),
            logout: apiRoutesPaths.logout.resolve(),
            session: apiRoutesPaths.session.resolve(),
        },
        appRoutes: {
            dashboard: { pathname: dashboardRoutesPaths.root.resolve() },
            home: { pathname: "/" },
            login: { pathname: authRoutesPaths.login.resolve() },
        },
    },
    {
        defaultTarget: "kraken",
        router: "pages-router",
    }
)
